export default {
  path: '/servico-at/:service_id/resumo',
  component: () =>
    import('@/components/pages/ATServices/ATServiceMeters')
}
